// ExamContext: Provides exam state and actions to all exam environment components
import React, { createContext, useContext, useReducer } from 'react';

const ExamContext = createContext();

const initialState = {
  examInfo: null, // { title, year, subject, ... }
  candidate: null, // { name, id, ... }
  questions: [], // [{...}]
  answers: {}, // { [questionId]: { answer, markedForReview, ... } }
  currentQuestion: 0,
  timer: 0, // seconds remaining
  status: 'not-started', // 'not-started' | 'in-progress' | 'submitted' | 'finished'
};

function examReducer(state, action) {
  switch (action.type) {
    case 'SET_EXAM_INFO':
      return { ...state, examInfo: action.payload };
    case 'SET_CANDIDATE':
      return { ...state, candidate: action.payload };
    case 'SET_QUESTIONS':
      return { ...state, questions: action.payload };
    case 'SET_ANSWER':
      return {
        ...state,
        answers: { ...state.answers, [action.qid]: action.payload },
      };
    case 'SET_CURRENT_QUESTION':
      return { ...state, currentQuestion: action.payload };
    case 'SET_TIMER':
      return { ...state, timer: action.payload };
    case 'SET_STATUS':
      return { ...state, status: action.payload };
    case 'RESET_EXAM':
      return initialState;
    default:
      return state;
  }
}

export function ExamProvider({ children, initialExam }) {
  const [state, dispatch] = useReducer(examReducer, {
    ...initialState,
    ...initialExam,
  });
  return (
    <ExamContext.Provider value={{ state, dispatch }}>
      {children}
    </ExamContext.Provider>
  );
}

export function useExam() {
  return useContext(ExamContext);
}
